document.addEventListener("DOMContentLoaded", function() {
	// Homepage Feature
	const homepageFeature = document.querySelectorAll('.mod-feature');
	if(homepageFeature) {
		homepageFeature.forEach(homepageFeatureBlock => {
			let homepageFeatureCarousel = homepageFeatureBlock.querySelector(".splide");
			let homepageFeaturePhotos = homepageFeatureBlock.querySelectorAll(".photo > img");
			let homepageFeatureArrows = homepageFeatureBlock.querySelector(".splide__arrows");

			if(homepageFeatureCarousel) {
				let homepageFeatureDelay = Number(homepageFeatureCarousel.getAttribute("data-slide-delay")) || 12;
				let homepageFeatureToggle;
				if(homepageFeatureArrows) {
					homepageFeatureToggle = document.createElement("button");
					homepageFeatureToggle.className = "splide__arrow photo-autoplay-toggle is-playing";
					homepageFeatureToggle.type = "button";
					homepageFeatureToggle.setAttribute("aria-label", "Pause slideshow");
					homepageFeatureToggle.innerHTML = '<span class="autoplay-icon" aria-hidden="true"></span>';
					homepageFeatureArrows.appendChild(homepageFeatureToggle);
				}

				const homepageFeatureSplide = new Splide(homepageFeatureCarousel, {
					type: 'loop',
					perPage: 1,
					perMove: 1,
					pagination: false,
					arrows: true,
					fixedHeight: true,
					autoplay: true,
					interval: homepageFeatureDelay * 1000,
					resetProgress: false,
					pauseOnHover: true,
					pauseOnFocus: true,
				});

				if(homepageFeatureToggle) {
					homepageFeatureToggle.addEventListener("click", function() {
						if(homepageFeatureSplide.Components.Autoplay.isPaused()) {
							homepageFeatureSplide.Components.Autoplay.play();
						} else {
							homepageFeatureSplide.Components.Autoplay.pause();
						}
					});
					homepageFeatureSplide.on("autoplay:play", function() {
						homepageFeatureToggle.classList.add("is-playing");
						homepageFeatureToggle.setAttribute("aria-label", "Pause slideshow");
					});
					homepageFeatureSplide.on("autoplay:pause", function() {
						homepageFeatureToggle.classList.remove("is-playing");
						homepageFeatureToggle.setAttribute("aria-label", "Play slideshow");
					});
				}

				homepageFeatureSplide.mount();

				// Change the photo when the carousel changes
		        homepageFeatureSplide.on( 'active', function(slide) {
		        	if(homepageFeaturePhotos[slide.index]) {
			        	homepageFeaturePhotos[slide.index].classList.add("active");
		        	}
		        });
		        homepageFeatureSplide.on( 'inactive', function(slide) {
		        	if(homepageFeaturePhotos[slide.index]) {
			        	homepageFeaturePhotos[slide.index].classList.remove("active");
		        	}
		        });
			}
		});
	}

	// Homepage Testimonial
	const homepageTestimonial = document.querySelectorAll('.mod-homepage-testimonials');
	if(homepageTestimonial) {
		homepageTestimonial.forEach(homepageTestimonialBlock => {
			let homepageTestimonialCarousel = homepageTestimonialBlock.querySelector(".splide");
			let homepageTestimonialMobilePhotos = homepageTestimonialBlock.querySelector(".photo-mobile");
			let homepageTestimonialDesktopPhotos = homepageTestimonialBlock.querySelector(".photo-desktop");

			if(homepageTestimonialCarousel) {
				const homepageTestimonialSplide = new Splide(homepageTestimonialCarousel, {
					type: 'slide',
					perPage: 1,
					perMove: 1,
					pagination: false,
					arrows: true,
				});

	        	// Because of how images work now, the carousel needs to check if the new slide has a photo or not
	        	homepageTestimonialSplide.on('move', function(newIndex, prevIndex, destIndex) {
	        		let currentMobileImage = homepageTestimonialBlock.querySelector("[data-index='"+newIndex+"']");
	        		let currentDesktopImage = homepageTestimonialBlock.querySelector("[data-index='"+newIndex+"']");
	        		if(currentMobileImage || currentDesktopImage) {
	        			homepageTestimonialBlock.classList.add("has-photo");
	        		} else {
	        			homepageTestimonialBlock.classList.remove("has-photo");
	        		}
	        	});

				homepageTestimonialSplide.mount();

				// Change the photo when the carousel changes
		        homepageTestimonialSplide.on( 'active', function(slide) {
		        	let newMobileActiveImage = homepageTestimonialMobilePhotos.querySelector("[data-index='"+slide.index+"']");
		        	let newDesktopActiveImage = homepageTestimonialDesktopPhotos.querySelector("[data-index='"+slide.index+"']");
		        	if(newMobileActiveImage) {
			        	newMobileActiveImage.classList.add("active");
		        	}
		        	if(newDesktopActiveImage) {
			        	newDesktopActiveImage.classList.add("active");
		        	}
		        });
		        homepageTestimonialSplide.on( 'inactive', function(slide) {
		        	let oldMobileActiveImage = homepageTestimonialMobilePhotos.querySelector("[data-index='"+slide.index+"']");
		        	let oldDesktopActiveImage = homepageTestimonialDesktopPhotos.querySelector("[data-index='"+slide.index+"']");
		        	if(oldMobileActiveImage) {
			        	oldMobileActiveImage.classList.remove("active");
		        	}
		        	if(oldDesktopActiveImage) {
			        	oldDesktopActiveImage.classList.remove("active");
		        	}
		        	homepageTestimonialSplide.refresh();
		        });

			}
		});
	}

	// Internal Resources
	const internalResources = document.querySelectorAll('.mod-internal-resources .splide');
	if(internalResources) {
		internalResources.forEach(resourceCarousel => {
			const resourceSplide = new Splide(resourceCarousel, {
				mediaQuery: "min",
				type: 'slide',
				perPage: 1,
				perMove: 1,
				pagination: true,
				arrows: true,
				fixedHeight: true,
				omitEnd: true,
	            breakpoints: {
	                1000: {
	                    destroy: true,
	                },
	            },
			});
			resourceSplide.mount();
		});
	}

	// Mobile Comparison Table
	const mobileCompareBlocks = document.querySelectorAll('.mod-comparison-chart .mobile-content');
	if(mobileCompareBlocks) {
		mobileCompareBlocks.forEach(mobileCompareBlock => {
			let compareCarousel = mobileCompareBlock.querySelector('.splide');
			const compareSplide = new Splide(compareCarousel, {
				type: 'slide',
				pagination: false,
				arrows: true,
				fixedHeight: true,
				drag: 'free',
				snap: false,
				autoWidth: true,
			});

	        // progress bar
	        let bar = mobileCompareBlock.querySelector('.carousel-controls .progress-bar');

	        if(bar) {
		        // Create a component(extension).
		        const ProgressBar = (Splide) => {
		            function progressBar() {
		                var end = compareSplide.Components.Controller.getEnd() + 1;
		                var rate = Math.min((compareSplide.index + 1) / end, 1);
		                bar.style.width = String(100 * rate) + "%";
		            }

		            // Return the component object.
		            return {
		                mount() {
		                    Splide.on("mounted move", progressBar);
		                },
		            };
		        };

		        // Call mount() with the component.
		        compareSplide.mount({ ProgressBar });
	        } else {
	        	compareSplide.mount();
	        }
		});
	}

	// Pinned Articles
	const pinnedArticles = document.querySelectorAll('.mod-blog-pinned-articles .splide');
	if(pinnedArticles) {
		pinnedArticles.forEach(pinnedArticleCarousel => {
			const pinnedArticleSplide = new Splide(pinnedArticleCarousel, {
				mediaQuery: "min",
				type: 'slide',
				perPage: 1,
				perMove: 1,
				pagination: true,
				arrows: true,
				fixedHeight: true,
				omitEnd: true,
	            breakpoints: {
	                1000: {
	                    destroy: true,
	                },
	            },
			});
			pinnedArticleSplide.mount();
		});
	}
});
